import { useEffect, useState } from 'react';
import { subscribeToPendingFileNotes } from '../services/firestoreService';

/** Count of pending file notes assigned to the current user. */
export function usePendingFileNotesCount(user, { enabled = true } = {}) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled || !user?.email) {
      setCount(0);
      return () => {};
    }
    return subscribeToPendingFileNotes(user.email, (notes) => {
      setCount(Array.isArray(notes) ? notes.length : 0);
    });
  }, [enabled, user?.email]);

  return count;
}
